import React, { useState, useEffect, useMemo, forwardRef, useImperativeHandle, useRef } from 'react';
import { Alert, FlatList, Platform, ScrollView, SectionList, TextInput, TouchableOpacity, View } from 'react-native'

import api from "../../../../../../utils/api"
import tw from '../../../../../../styles/tailwind';
import Text from '../../../../../../components/Text';
import Icon from '../../../../../../components/IcomoonIcon';
import { Image } from 'expo-image';
import { useQuery } from '@tanstack/react-query';
import { useNavigation, useRoute } from '@react-navigation/native';
import IconButton from '../../../../../../components/IconButton';
import AddPaymentModal from '../AddPaymentModal';
import { ProgressBar, useProgressPercentAnimation } from '../FeeDetailScreen';

import CreateFeeModal from '../CreateFeeModal';
import TabsSelector from '../../../../../../components/TabsSelector';
import Modal from '../../../../../../components/Modal';
import useActiveAdminCommunity from '../../../../../../hooks/useActiveAdminCommunity';
import dayjs from 'dayjs';
import EditPaymentModal from './EditPaymentModal';


export default function PaymentDetailModal({ onRequestClose, paymentId, onPaymentEdited, onPaymentDeleted }){
  const {communityId} = useActiveAdminCommunity()
  const [showEditModal, setShowEditModal] = useState(false);

  const { isLoading, error, data: payment, refetch } = useQuery({
    queryKey: ['community.payment.detail', communityId, paymentId],
    queryFn: () => api.get(`/communities/${communityId}/payments/${paymentId}`).then(response => response.data),
  })

  const applyDate = payment?.apply_date ? dayjs(payment.apply_date) : null

  const confirmPaymentDeletion = () => {
    if(Platform.OS === "web"){
      if(confirm("¿Eliminar este pago?\nEsta acción no podrá deshacerse")){
        submitDeletion()
      }
    }else{
      Alert.alert('¿Eliminar este pago?', 'Esta acción no podrá deshacerse', [
        {
          text: 'Cancelar',
          onPress: () => { },
          style: 'cancel',
        },
        { text: 'Eliminar', onPress: () => submitDeletion() },
      ]);
    }
  }

  const submitDeletion = () => {
    api.delete(`/communities/${communityId}/payments/${paymentId}`)
    .then(response => onPaymentDeleted?.())
    .catch(err => {

    })
  }

  return (
    <Modal
      onRequestClose={onRequestClose}
      style={{modal: `w-[480px] max-w-[90%]`}}
    >
      {
        payment &&
          <View>
            <Text style={tw`text-secondary font-600 text-lg`}>Detalle de pago</Text>

            <View style={tw`row justify-between items-start mt-3`}>
              <View style={tw`flex-1`}>
                {
                  payment.folio &&
                    <Text style={tw`text-secondary font-600 text-base`}>#{payment.folio}</Text>
                }

                {
                  payment.payment_method &&
                    <Text style={tw`text-gray-500`}>{payment.payment_method?.name}</Text>
                }

                <Text style={tw`text-gray-500`}>{payment.unit?.name}</Text>

                {
                  applyDate &&
                    <Text style={tw`text-gray-500`}>{applyDate.format('DD/MM/YYYY')}</Text>
                }
              </View>

              <View style={tw`items-end`}>
                <Text style={tw`text-primary font-600`}>{payment.status_str}</Text>
                <Text style={tw`text-secondary font-600 text-xl`}>${payment.amount}</Text>
              </View>
            </View>


            <Text style={tw`text-lg text-gray-500 mt-4 mb-2`}>Cuotas cubiertas</Text>

            <View style={tw`bg-[#F9FAFB] rounded-2xl border border-gray-200 px-4 py-3 gap-y-2`}>
              {
                payment.fee_units?.map(fee_unit =>
                  <View style={tw`row justify-between`} key={fee_unit.uuid}>
                    <Text>{fee_unit.fee.name}</Text>

                    <Text>${(fee_unit.paid)}</Text>
                  </View>
                )
              }
            </View>

            <View style={tw`border-t border-gray-200 mt-3 pt-3 row justify-between`}>
              <TouchableOpacity onPress={confirmPaymentDeletion}>
                <Text style={tw`text-red`}>Eliminar pago</Text>
              </TouchableOpacity>

              <TouchableOpacity onPress={() => setShowEditModal(true)}>
                <Text style={tw`text-gray-500`}>Editar pago</Text>
              </TouchableOpacity>
            </View>
        </View>
      }

      {
        showEditModal &&
          <EditPaymentModal
            payment={payment}
            onRequestClose={() => setShowEditModal(false)}
            visible
            onPaymentEdited={() => {
              setShowEditModal(false)
              refetch()
              onPaymentEdited?.()
            }}
          />
      }
    </Modal>
  )
}